export default {
  openSettings: () => {},
};
